<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="user"/>&nbsp;Crear Corte de Pago
        </div>
      </div>
      <div class="card-body pb-5">
        <!--begin: Details -->
          <div class="row mt-4">
            <div class="col-sm-6">
              <h4 class="font-info">Datos Generales</h4>
            </div>
          </div>
          <sys-form :inputs="monthly_cut_details"/>
        <!--end: Details -->
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" @click="$router.push({ name: 'monthly_cuts' })">
          <fai icon="reply"/> Cancelar
        </button>
        <button class="btn btn-success" :class="{ 'disabled': form.isSaving }" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import monthlyCutService from '@/services/monthly_cuts'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'

export default {
  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      monthly_cut_details: {
        cut_day: {
          name: 'Día de corte',
          hint: 'Día de corte',
          value: null,
          type: 'select',
          options: [
            { value: '7', text: 'Día 7' },
            { value: '15', text: 'Día 15' },
            { value: '21', text: 'Día 21' },
            { value: 'last_day', text: 'Ultimo día del mes' }
          ],
          validate: 'required'
        },
        month: {
          name: 'Mes',
          hint: 'Mes',
          value: null,
          type: 'select',
          options: [
            { value: 1, text: 'Enero' },
            { value: 2, text: 'Febrero' },
            { value: 3, text: 'Marzo' },
            { value: 4, text: 'Abril' },
            { value: 5, text: 'Mayo' },
            { value: 6, text: 'Junio' },
            { value: 7, text: 'Julio' },
            { value: 8, text: 'Agosto' },
            { value: 9, text: 'Septiembre' },
            { value: 10, text: 'Octubre' },
            { value: 11, text: 'Noviembre' },
            { value: 12, text: 'Diciembre' }
          ],
          validate: 'required'
        },
        year: {
          name: 'Año',
          hint: 'Año',
          value: '',
          type: 'number',
          min: 2018,
          max: 2200,
          validate: 'required'
        }
      }
    }
  },

  created: function () {},

  methods: {
    saveForm: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let body = this.processForm(this.monthly_cut_details)
          let service = monthlyCutService.post(body)

          this.sendForm(service).then(res => {
            this.$router.push({ name: 'monthly_cuts', props: { monthly_cuts: res } })
          }).catch(err => {
            console.log(JSON.stringify(err))
          })
        }
      })
    }
  },

  watch: {}
}
</script>

<style lang="scss" scoped>
.font-info {
  font-size: 1.5rem;
  color: var(--primary);
}
</style>



// WEBPACK FOOTER //
// src/components/monthly_cuts/MonthlyCutCreate.vue